<!--
 * @Description: 分销推广dialog
 * @Author: Gavin
 * @version: 
 * @Date: 2020-09-01 15:06:27
 * @LastEditTime: 2020-09-01 15:18:05
-->
<template>
  <md-dialog
    :closable="false"
    transition="md-bounce"
    v-model="visible"
    class="promotion-hint-dialog">
    <span class="icon-box"></span>
    <p class="title">{{title}}</p>
    <p class="desc">{{message}}</p>
    <md-button type="primary" @click="handleDialogConfirm">{{btnText}}</md-button>
  </md-dialog>
</template>

<script>
import { Dialog } from 'mand-mobile'

export default {
  name: "nr-promotion-dialog",
  data() {
    return {
      visible: false
    }
  },
  props: {
    title: {
      type: String,
      default: '温馨提示'
    },
    message: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: '我知道了'
    }
  },
  components: {
    [Dialog.name]: Dialog
  },
  methods: {
    show() {
      this.visible = true;
    },
    handleDialogConfirm() {
      this.visible = false;
      this.$emit('onConfirm')
    }
  }
}
</script>

<style lang="scss">
.promotion-hint-dialog{

  .md-popup-box,.md-dialog-content{
    overflow: visible;
  }
  .icon-box{
    width: 96px;
    height: 96px;
    display: block;
    margin: 0 auto;
    border-radius: 50%;
    position: absolute;
    top: -42px;
    left: 50%;
    transform: translateX(-50%);
    background: url('./img/rule-hint.svg') no-repeat;
    background-size: contain;
  }
  .title{
    color: #333333;
    text-align: center;
    font-size: 32px;
    margin-top: 24px;
  }
  .desc{
    color: #999999;
    margin-top: 30px;
    line-height: 1.4;
  }

  .md-button{
    margin: 20px auto 0;
    width: 240px;
    border: none;
    border-radius: 8px;
    height: 80px;
    line-height: 80px;
    background: linear-gradient(132deg, #F87A5A 0%, #E9125B 100%);

    &.active:active{
      background: linear-gradient(132deg, #f38f75 0%, #ef407b 100%);
    }
    &::after{
      border: none;
    }
  }
}
</style>